/** True when pathname is the EMR patient listing (not an open encounter). */
export function isEmrLandingRoute(pathname: string): boolean {
  return /\/patient-care\/emr-listing/i.test(pathname);
}
